<template>
  <div class="tabs-block">
    <v-row>
      <v-col cols="12" sm="12" md="3" v-for="(tab, key) in tabs" :key="`tab${key}`">
        <v-card :class="{ 'tab-item--active': activeTab === tab.name }" class="tab-item mx-auto" outlined>
          <v-list-item four-line>
            <v-list-item-content>
              <v-list-item-title class="headline tab-item__title mb-1 text-center">{{ tab.title }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-center tab-item__text" v-html="tab.text">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-btn @click="setActiveTab(tab.name)" block color="primary" class="ctaButton">Find Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import tabTypes from "@/utils/tabTypes";

const tabs = [
  {
    name: tabTypes.inHome,
    title: "In-Home Service Provider",
    text: "View a list of In-Home Service Provider in&nbsp;your&nbsp;Area",
  },
  {
    name: tabTypes.retail,
    title: "In-Store",
    text: "View a List of Retail Stores in&nbsp;your&nbsp;Area",
  },
  {
    name: tabTypes.buyOnline,
    title: "Buy Online",
    text: "View a List of Websites to&nbsp;Buy&nbsp;Online",
  },
  {
    name: tabTypes.international,
    title: "International Sales",
    text: "View a List of International Representatives",
  }
]

export default {
  name: 'SectionTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabs,
      tabTypes: tabTypes,
    }
  },
  methods: {
    setActiveTab: function (tab) {
      if (tab === tabTypes.international) {
        window.open("/international-representatives/", "_top");
      } else if (tab === tabTypes.buyOnline) {
          window.open("/where-to-buy/buy-online/", "_blank");
      } else {
        this.$emit('set-active-tab', tab);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.tabs-block {
  margin-bottom: 24px;
}

.tab-item {
  transition: all 0.5s;

  &--active {
    border: thin solid #eb3a43 !important;
  }

  &:hover {
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.18), 0 5px 5px rgba(0, 0, 0, 0.12) !important;
  }

  &__title {
    white-space: normal;
    line-height: 1.1;
    min-height: 54px;
  }

  &__text {
    white-space: normal;
  }
}
</style>
